module.exports = __webpack_public_path__ + "static/media/color.4dfed4f1.svg";